/**
 *  配电表计管理
 */
import * as HttpService from "../../../../service/HttpService";

/**
 * 查询模板列表
 */
export const queryReportList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/reportData/getReportCustMeasDataCustom", params);
};

/**
 * 查询模板列表
 */
export const delOneReportCustMeasData = (idStr) => {
    return HttpService.post(HttpService.DOMAIN + "/reportData/delOneReportCustMeasData?idStr="+idStr);
};